/* All ring products: put the existing, form-associated size select in the options
   panel, OUTSIDE variant-picker. Native size variants stay inside variant-picker. */
(() => {
  if (window.asRingSizeDropdownLoaded) return;
  window.asRingSizeDropdownLoaded = true;
  const mounted = new Map();
  const selectedSizes = new Map();
  let queued = false;
  const roots = '#MainContent .product-details as-product-personalization[data-as-compact-product]';
  const typography = ['font-family', 'font-size', 'font-weight', 'font-style', 'line-height', 'letter-spacing', 'text-transform', 'text-align'];

  function copyAppearance(panel, row) {
    const source = panel.querySelector('variant-picker .as-center-stone-option select') ||
      panel.querySelector('variant-picker .variant-option select');
    const target = row.querySelector('[data-as-ring-size-dropdown]');
    const sourceRow = source?.closest('.variant-option');
    if (!source || !sourceRow || !target) return;
    const inherited = getComputedStyle(sourceRow);
    for (const property of inherited) {
      if (property.startsWith('--color-variant-') || property.startsWith('--variant-option-label-') ||
          property.startsWith('--style-border-') || property.startsWith('--focus-outline-')) {
        row.style.setProperty(property, inherited.getPropertyValue(property));
      }
    }
    const style = getComputedStyle(source);
    for (const property of [...typography, 'box-sizing', 'height', 'min-height', 'padding-top', 'padding-right', 'padding-bottom', 'padding-left', 'appearance']) {
      target.style.setProperty(property, style.getPropertyValue(property));
    }
    const sourceLabel = sourceRow.querySelector('label');
    const targetLabel = row.querySelector('label');
    if (sourceLabel && targetLabel) {
      const labelStyle = getComputedStyle(sourceLabel);
      for (const property of [...typography, 'display', 'margin-top', 'margin-bottom', 'color']) {
        targetLabel.style.setProperty(property, labelStyle.getPropertyValue(property));
      }
    }
  }

  function scan() {
    queued = false;
    for (const [root, state] of mounted) {
      if (!root.isConnected) {
        state.controller.abort();
        state.row.remove();
        mounted.delete(root);
      }
    }
    document.querySelectorAll(roots).forEach((root) => {
      let state = mounted.get(root);
      const row = root.querySelector('[data-as-ring-size-control]') || state?.row;
      const slot = root.closest('.product-details')?.querySelector('[data-as-inline-ring-size-slot]');
      const panel = slot?.closest('[data-as-inline-options]');
      const select = row?.querySelector('[data-as-ring-size-dropdown]');
      if (!row || !slot || !panel || !select) return;
      if (!state || state.row !== row) {
        state?.controller.abort();
        const controller = new AbortController();
        const key = `${root.dataset.productId}:${root.dataset.productFormId}`;
        const remembered = selectedSizes.get(key);
        if (remembered !== undefined && Array.from(select.options).some((option) => option.value === remembered && !option.disabled)) {
          select.value = remembered;
        }
        const remember = () => selectedSizes.set(key, select.value);
        select.addEventListener('change', remember, { signal: controller.signal });
        select.addEventListener('input', remember, { signal: controller.signal });
        remember();
        state = { row, select, key, controller, panel };
        mounted.set(root, state);
      }
      state.panel = panel;
      if (row.parentElement !== slot) slot.replaceChildren(row);
      slot.hidden = false;
      root.classList.toggle('as-personalization--empty', !root.querySelector('.as-personalization__panel'));
      copyAppearance(panel, row);
    });
  }
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(scan);
  }
  function start() {
    scan();
    const main = document.getElementById('MainContent');
    if (main) new MutationObserver((records) => {
      if (records.some((record) => [...record.addedNodes, ...record.removedNodes].some((node) => node.nodeType === 1))) schedule();
    }).observe(main, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', schedule);
    document.addEventListener('reset', (event) => requestAnimationFrame(() => {
      for (const state of mounted.values()) {
        if (state.select.form === event.target) selectedSizes.set(state.key, state.select.value);
      }
    }), true);
    window.addEventListener('resize', schedule, { passive: true });
    document.fonts?.ready.then(schedule);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
